import styled from 'styled-components';

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #de1515;
  margin: 4px 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextContainer = styled.div`  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 5px;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  margin-bottom: 5px;
  transition: 200ms;
`;

export const FirstSubtitle = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.grey_text};

  transition: 200ms;
  font-weight: 700;
`;
export const Subtitle = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.grey_text};
  text-align: end;
  transition: 200ms;
  
`;

